import React, { useState, useEffect, useReducer, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import SmartFMnav from '../Assets/SmartFMnav.svg';
import Otp from '../Assets/Otp.svg';
import '../css/signup.css';
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import ReCAPTCHA from "react-google-recaptcha";
import moment from 'moment';
import CommonAPISelect from '../Components/Helpercomponents/CommonAPIMthod';

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import SaasProducts from './Products';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const OTP_LENGTH = 4;
const RESEND_SECONDS = 30;
const RECAPTCHA_SITE_KEY =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeHjhcsAAAAAEpcqUBNkMhl_ROdO-cF-y5glViw";

const EMPLOYEE_RANGES = [
    { id: 1, label: '1 - 100' },
    { id: 2, label: '101 - 500' },
    { id: 3, label: '501 - 1000' },
    { id: 4, label: 'Above 1000' },
];

const initialState = {
    UserFirstName: '',
    UserLastName: '',
    UserContactNo: '',
    CompanyName: '',
    NoOfEmps: '',
    UserEmail: '',
    UserPassword: '',
    ConfirmPassword: '',
    phoneCountryCode: '',
    phoneCountryName: '',
    AdminProductID: 0,
    IsEmailVerified: false,
    selectedEmployeeId: null,
    userID:null
};



// Defined outside the component so it is not re-created on every render.
function reducer(state, action) {
    switch (action.type) {
        case 'RESET':
            return initialState;
        case 'SET':
            return { ...state, [action.name]: action.payload };
        default:
            return state;
    }
}

const trimFunc = (v) => (typeof v === 'string' ? v.trim() : v);

// The backend returns `Output` either as an object or as an array; normalise it.
const getOutput = (res) => (Array.isArray(res?.Output) ? res.Output[0] : res?.Output);
const isOk = (out) => String(out?.status?.code) === '200';

const EyeIcon = ({ open }) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {open ? (
            <>
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
            </>
        ) : (
            <>
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
            </>
        )}
    </svg>
);

export default function SignUpPage() {
    const navigate = useNavigate();

    const [state, dispatch] = useReducer(reducer, initialState);
    const [clientImages, setClientImages] = useState([]);
    const [errors, setErrors] = useState({});
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [sendingOtp, setSendingOtp] = useState(false);
    const [verifyingOtp, setVerifyingOtp] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [resendIn, setResendIn] = useState(0);
    const [newTab,setnewTab] =useState('productlist')

    const otpRefs = useRef([]);
    const phoneRef = useRef(null);
    const itiRef = useRef(null);
    const passwordRef = useRef(null);
    const captchaRef = useRef(null);

    const setField = (name, payload) => dispatch({ type: 'SET', name, payload });

    const emailValid = EMAIL_RE.test(state.UserEmail.trim());
    const emailTouchedInvalid = state.UserEmail.trim() !== '' && !emailValid;
    const passwordsEnabled = state.IsEmailVerified;

    /* ---------- phone input (intl-tel-input) ---------- */
    useEffect(() => {
        const input = phoneRef.current;
        if (!input) return;

        const iti = intlTelInput(input, {
            initialCountry: "in",
            separateDialCode: true,
            preferredCountries: ["in", "ae", "sa"],
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
        });
        itiRef.current = iti;

        const updateCountry = () => {
            const c = iti.getSelectedCountryData();
            dispatch({ type: 'SET', name: 'phoneCountryCode', payload: c.dialCode ? `+${c.dialCode}` : '' });
            dispatch({ type: 'SET', name: 'phoneCountryName', payload: c.name || '' });
        };

        // The input is intentionally UNCONTROLLED: intl-tel-input owns its value,
        // and we only mirror the digits into state.
        const handleInput = () => {
            const digits = input.value.replace(/\D/g, '');
            if (digits !== input.value) input.value = digits;
            dispatch({ type: 'SET', name: 'UserContactNo', payload: digits });
            setErrors((p) => (p.UserContactNo ? { ...p, UserContactNo: '' } : p));
        };

        input.addEventListener("countrychange", updateCountry);
        input.addEventListener("input", handleInput);
        updateCountry();

        return () => {
            input.removeEventListener("countrychange", updateCountry);
            input.removeEventListener("input", handleInput);
            iti.destroy();
            itiRef.current = null;
        };
    }, []);

    /* ---------- client logos ---------- */
    useEffect(() => {
        const controller = new AbortController();
        (async () => {
            try {
                const response = await fetch(
                    "https://cms-data.smartfm.in/wp-json/wp/v2/media?page=1&per_page=100&orderby=id&order=asc&_fields=id,guid,title",
                    { signal: controller.signal }
                );
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                const images = await response.json();
                if (Array.isArray(images) && images.length) setClientImages(images);
            } catch (error) {
                if (error.name !== 'AbortError') console.error("Error fetching images:", error);
            }
        })();
        return () => controller.abort();
    }, []);

    /* ---------- resend cooldown ---------- */
    useEffect(() => {
        if (resendIn <= 0) return;
        const t = setTimeout(() => setResendIn((s) => s - 1), 1000);
        return () => clearTimeout(t);
    }, [resendIn]);

    /* ---------- OTP ---------- */
    const clearOtpInputs = () => otpRefs.current.forEach((el) => { if (el) el.value = ''; });

    const handleOtpChange = (e, index) => {
        const digit = e.target.value.replace(/\D/g, '');
        e.target.value = digit;
        if (digit && index < OTP_LENGTH - 1) otpRefs.current[index + 1]?.focus();
    };

    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            otpRefs.current[index - 1]?.focus();
        }
    };

    const handleOtpPaste = (e) => {
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, OTP_LENGTH);
        if (!pasted) return;
        e.preventDefault();
        pasted.split('').forEach((ch, i) => { if (otpRefs.current[i]) otpRefs.current[i].value = ch; });
        otpRefs.current[Math.min(pasted.length, OTP_LENGTH - 1)]?.focus();
    };

    const handleSendOTP = async (resend) => {
        if (!state.UserFirstName.trim() || !emailValid) {
            toast.warn("Please enter your first name and a valid email");
            return;
        }
        if (sendingOtp || resendIn > 0) return;

        setSendingOtp(true);
        try {
            const endPoint = resend ? '/resendOTP': "/sendOTP"
            const url = `${process.env.REACT_APP_NODE_SERVICE}${endPoint}` ;
            const payload = { data: { UserName: state.UserFirstName.trim(), email: state.UserEmail.trim() } };
            const res = await CommonAPISelect(url, payload);
            const out = getOutput(res);

            if (isOk(out)) {
                toast.success(out?.status?.message || "Mail sent successfully");
                setResendIn(RESEND_SECONDS);
                clearOtpInputs();
                setShowOtpModal(true);
                setTimeout(() => otpRefs.current[0]?.focus(), 50);
            } else {
                toast.warn(out?.status?.message || "Failed to send mail");
            }
        } catch (err) {
            console.error(err);
            toast.error("Could not send OTP. Please try again.");
        } finally {
            setSendingOtp(false);
        }
    };

    const handleVerifyOTP = async () => {
        if (!emailValid) {
            toast.warn("Please enter a valid email");
            return;
        }
        const otp = otpRefs.current.map((el) => el?.value || '').join('');
        if (otp.length !== OTP_LENGTH) {
            toast.warn(`Please enter the ${OTP_LENGTH}-digit OTP`);
            return;
        }

        setVerifyingOtp(true);
        try {
            const url = process.env.REACT_APP_NODE_SERVICE + "/verifyOTP";
            const payload = { data: { otp, email: state.UserEmail.trim() } };
            const res = await CommonAPISelect(url, payload);
            const out = getOutput(res);

            if (isOk(out) && Array.isArray(out?.data) && out.data.length > 0) {
                toast.success(out?.status?.message || "Email verified");
                setField('IsEmailVerified', true);
                setShowOtpModal(false);
                setErrors((p) => ({ ...p, email: '' }));
                setTimeout(() => passwordRef.current?.focus(), 50);
            } else {
                toast.warn("Invalid OTP");
            }
        } catch (err) {
            console.error(err);
            toast.error("Could not verify OTP. Please try again.");
        } finally {
            setVerifyingOtp(false);
        }
    };

    /* ---------- field handlers ---------- */
    const handleEmailChange = (e) => {
        setField('UserEmail', e.target.value);
        // Changing the email invalidates any earlier verification.
        if (state.IsEmailVerified) {
            setField('IsEmailVerified', false);
            setField('UserPassword', '');
            setField('ConfirmPassword', '');
        }
        if (errors.email) setErrors((p) => ({ ...p, email: '' }));
    };

    const handleChange = (name, errKey) => (e) => {
        setField(name, e.target.value);
        if (errKey && errors[errKey]) setErrors((p) => ({ ...p, [errKey]: '' }));
    };

    const handleSelectEmployees = (range) => {
        setField('NoOfEmps', range.label);
        setField('selectedEmployeeId', range.id);
        if (errors.noOfEmps) setErrors((p) => ({ ...p, noOfEmps: '' }));
    };

    /* ---------- validation ---------- */
    const validate = () => {
        const e = {};
        if (!state.UserFirstName.trim()) e.firstName = 'First name is required';

        const iti = itiRef.current;
        const phoneCheck = iti ? iti.isValidNumber() : null;
        const phoneOk = typeof phoneCheck === 'boolean' ? phoneCheck : state.UserContactNo.length >= 7;
        if (!state.UserContactNo) e.UserContactNo = 'Mobile number is required';
        else if (!phoneOk) e.UserContactNo = 'Please enter a valid mobile number';

        if (!state.CompanyName.trim()) e.company = 'Company name is required';
        if (!state.NoOfEmps) e.noOfEmps = 'Please select number of employees';

        if (!emailValid) e.email = 'Please enter a valid email address';
        else if (!state.IsEmailVerified) e.email = 'Please verify your email';

        if (state.UserPassword.length < 8) e.password = 'Password must be at least 8 characters';
        if (!state.ConfirmPassword) e.confirmPassword = 'Please confirm your password';
        else if (state.UserPassword !== state.ConfirmPassword) e.confirmPassword = 'Passwords do not match';

        setErrors(e);
        return Object.keys(e).length === 0;
    };

    /* ---------- submit ---------- */
    const handleSignUp = async () => {
        if (submitting) return;
        // if (!captchaVerified) {
        //     toast.warn("Please verify the captcha");
        //     return;
        // }
        if (!validate()) return;

        const now = moment().format("YYYY-MM-DD HH:mm:ss"); // HH = 24h (hh would be 12h with no AM/PM)
        const SubmitParam = {
            data: [{
                p1: 0,
                p2: trimFunc(state.UserFirstName) || "",
                p3: trimFunc(state.UserLastName) || "",
                p4: trimFunc(state.UserContactNo) || "",
                p5: trimFunc(state.CompanyName) || "",
                p6: trimFunc(state.NoOfEmps) || "",
                p7: trimFunc(state.UserEmail) || "",
                p8: trimFunc(state.UserPassword) || "",
                p9: state.IsEmailVerified || false,
                p10: false,
                p11: false,
                p12: trimFunc(state.ConfirmPassword) || "",
                p13: true,
                p14: false,
                p15: '1',
                p16: now,
                p17: '1',
                p18: now
            }],
        };

        const saveurl = process.env.REACT_APP_NODE_SERVICE + "/FP9S1";
        const seekurl = process.env.REACT_APP_NODE_SERVICE + "/FP9S2";

        setSubmitting(true);
        try {
            // 1) validation / duplicate check
            const seekOut = await CommonAPISelect(seekurl, SubmitParam);
            
            if (seekOut?.[0]?.Data?.length > 0) {

                const alerts = (seekOut?.[0]?.Data || []).filter((v) => v && String(v.IsAlert) === "1");
                if (alerts.length) {
                    setSubmitting(false);
                    alerts.forEach((a) => toast.warn(a.AlertMessage));
                    return;
                }
            }

            if (seekOut?.[0]?.Data?.length == 0) {
                saveSubmit(saveurl, SubmitParam)
            }
        } catch (err) {
            console.error("Sign up error:", err);
            toast.error("Network error. Please try again.");
        } finally {
            // setSubmitting(false);
        }
    };

    async function saveSubmit(saveurl, SubmitParam) {
        const res = await CommonAPISelect(saveurl, SubmitParam)

        const status = res[0]?.status || {};
        if (status.code == 200) {
            toast.success("Account created successfully");
            setnewTab('thankspage')
            // navigate("/products");
            dispatch({ type: 'SET', name: 'userID', payload: res[0]?.Data?.IDPK || '' });
            
        } else {
            toast.warn(status.message || 'Account creation failed');
        }

    }


    const clear = () => {
        dispatch({ type: 'RESET' });
        setErrors({});
        setCaptchaVerified(false);
        captchaRef.current?.reset();
        if (phoneRef.current) phoneRef.current.value = '';
    }

    /* ---------- render ---------- */
    return (
        <div className='WebSaasParentContainer'>
            <ToastContainer position="top-center" autoClose={2000} hideProgressBar />

            {showOtpModal && (
                <div className="OtpModalOverlay" style={{ display: 'flex' }}>
                    <div className="OtpModal" role="dialog" aria-modal="true" aria-label="OTP verification">
                        <div className="OtpModalClose" onClick={() => setShowOtpModal(false)}>&times;</div>

                        <img src={Otp} alt="OTP" title="OTP" className="OtpImage" />
                        <h3 className="OtpModalTitle">OTP Verification</h3>
                        <p className="OtpModalSubTitle">
                            Please enter the OTP sent to your email id{' '}
                            <span style={{ color: '#222' }}>({state.UserEmail})</span> to complete your verification
                        </p>

                        <div className="OtpInputContainer" onPaste={handleOtpPaste}>
                            {Array.from({ length: OTP_LENGTH }, (_, i) => (
                                <input
                                    key={i}
                                    type="text"
                                    inputMode="numeric"
                                    autoComplete="one-time-code"
                                    maxLength={1}
                                    className="OtpInputStyle"
                                    ref={(el) => (otpRefs.current[i] = el)}
                                    onChange={(e) => handleOtpChange(e, i)}
                                    onKeyDown={(e) => handleOtpKeyDown(e, i)}
                                />
                            ))}
                        </div>

                        <p className="OtpResend">
                            Didn’t get the code?{' '}
                            <span
                                className="OtpResendLink"
                                onClick={() => {
                                    if (resendIn === 0) handleSendOTP(true);
                                }}
                                style={{ opacity: resendIn > 0 ? 0.5 : 1, cursor: resendIn > 0 ? 'default' : 'pointer' }}
                            >
                                {resendIn > 0 ? `Resend in ${resendIn}s` : 'Resend'}
                            </span>
                        </p>

                        <div className="OtpVerifyCancelSec">
                            <button type="button" className="OtpCancelBtn" onClick={() => setShowOtpModal(false)}>Cancel</button>
                            <button type="button" className="OtpVerifyBtn" onClick={handleVerifyOTP} disabled={verifyingOtp}>
                                {verifyingOtp ? 'Verifying...' : 'Verify OTP'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            { newTab =='productlist' && <div className='WebSaasSubContainer'>
                <div className='WebSaasContentContainer'>
                    <img src={SmartFMnav} className="WebSassLogoImage" alt="SmartFM" title="SmartFM Logo" />
                    <p className="WebSaasContentText">
                        SMART FM goes beyond simply managing assets. It empowers your workforce with intuitive tools and
                        real-time data to unlock high-performance. Say goodbye to scattered work orders, paper trails,
                        and inefficient processes. With SMART FM, you gain a centralized platform.
                    </p>
                    <div className='client-section'>
                        <div className='client-slider'>
                            <div className='client-slide'>
                                {clientImages.map((x) => (
                                    <img key={x.id} src={x?.guid?.rendered || ''} alt={x?.title?.rendered || ''} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='WebSaasSignUpContainer'>
                    <div className="SignUpContainer">
                        <h3 className="SignUpTitle">Sign Up</h3>

                        <div className="InputContainerParent">
                            <div className="InputContainer50">
                                <label className="InputLabel" htmlFor="UserFirstName">
                                    First Name<span className="MandatorySym">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="UserFirstName"
                                    className="InputStyle"
                                    value={state.UserFirstName}
                                    onChange={handleChange('UserFirstName', 'firstName')}
                                    placeholder="Enter your first name" />
                                {errors.firstName && <span className="ErrorText">{errors.firstName}</span>}
                            </div>
                            <div className="InputContainer50">
                                <label className="InputLabel" htmlFor="UserLastName">Last Name</label>
                                <input
                                    type="text"
                                    id="UserLastName"
                                    className="InputStyle"
                                    value={state.UserLastName}
                                    onChange={handleChange('UserLastName')}
                                    placeholder="Enter your last name" />
                            </div>
                        </div>

                        <div className="InputContainer100">
                            <label className="InputLabel" htmlFor="UserContactNo">
                                Mobile Number<span className="MandatorySym">*</span>
                            </label>
                            {/* Uncontrolled on purpose – intl-tel-input manages this value */}
                            <input
                                type="tel"
                                id="UserContactNo"
                                className="InputStyle"
                                ref={phoneRef}
                                placeholder="Enter your mobile number" />
                            {errors.UserContactNo && <span className="ErrorText">{errors.UserContactNo}</span>}
                        </div>

                        <div className="InputContainer100">
                            <label className="InputLabel" htmlFor="CompanyName">
                                Company Name<span className="MandatorySym">*</span>
                            </label>
                            <input
                                type="text"
                                id="CompanyName"
                                className="InputStyle"
                                value={state.CompanyName}
                                onChange={handleChange('CompanyName', 'company')}
                                placeholder="Enter your company name" />
                            {errors.company && <span className="ErrorText">{errors.company}</span>}
                        </div>

                        <div className="InputContainer100">
                            <span className="InputLabel" id="NoOfEmpLabel">
                                Number of Employees<span className="MandatorySym">*</span>
                            </span>
                            <div className="NoOfEmpContainer" role="radiogroup" aria-labelledby="NoOfEmpLabel">
                                {EMPLOYEE_RANGES.map((x) => {
                                    const active = state.selectedEmployeeId === x.id;
                                    return (
                                        <button
                                            key={x.id}
                                            type="button"
                                            role="radio"
                                            aria-checked={active}
                                            className={`NoOfEmps${active ? ' NoOfEmps--active' : ''}`}
                                            onClick={() => handleSelectEmployees(x)}
                                        >
                                            {x.label}
                                        </button>
                                    );
                                })}
                            </div>
                            {errors.noOfEmps && <span className="ErrorText">{errors.noOfEmps}</span>}
                        </div>

                        <div className="InputContainer100">
                            <label className="InputLabel" htmlFor="UserEmail">
                                Email<span className="MandatorySym">*</span>
                            </label>
                            <input
                                type="email"
                                id="UserEmail"
                                className="InputStyle"
                                placeholder="Enter your email id"
                                value={state.UserEmail}
                                onChange={handleEmailChange} />
                            {emailTouchedInvalid && <span className="ErrorText">Please enter a valid email address</span>}
                            {errors.email && !emailTouchedInvalid && <span className="ErrorText">{errors.email}</span>}

                            {emailValid && !state.IsEmailVerified && (
                                <span
                                    className="SendOtpText"
                                    style={{ display: 'inline-block', opacity: sendingOtp ? 0.6 : 1 }}
                                    onClick={()=>{handleSendOTP(false)}}>
                                    {sendingOtp ? 'Sending OTP...' : 'Verify your account'}
                                </span>
                            )}
                            {state.IsEmailVerified && (
                                <span className="EmailAlertText" style={{ display: 'inline-block', color: '#1a9c4b' }}>
                                    ✓ Email verified
                                </span>
                            )}
                        </div>

                        <div className="InputContainer100">
                            <label className="InputLabel" htmlFor="UserPassword">
                                Password<span className="MandatorySym">*</span>
                            </label>
                            <div className="PasswordWrapper">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="UserPassword"
                                    className="InputStyle"
                                    style={{ paddingRight: '40px' }}
                                    placeholder={passwordsEnabled ? "Enter your password" : "Verify your email first"}
                                    autoComplete="new-password"
                                    disabled={!passwordsEnabled}
                                    ref={passwordRef}
                                    value={state.UserPassword}
                                    onChange={handleChange('UserPassword', 'password')}
                                />
                                <button
                                    type="button"
                                    className="PasswordToggleBtn"
                                    onClick={() => setShowPassword((p) => !p)}
                                    disabled={!passwordsEnabled}
                                    aria-label={showPassword ? "Hide password" : "Show password"}>
                                    <EyeIcon open={showPassword} />
                                </button>
                            </div>
                            {errors.password && <span className="ErrorText">{errors.password}</span>}
                            <span className="PasswordAlertText">Minimum length: 8 characters</span>
                        </div>

                        <div className="InputContainer100">
                            <label className="InputLabel" htmlFor="ConfirmPassword">
                                Confirm Password<span className="MandatorySym">*</span>
                            </label>
                            <div className="PasswordWrapper">
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    id="ConfirmPassword"
                                    className="InputStyle"
                                    style={{ paddingRight: '40px' }}
                                    placeholder="Confirm your password"
                                    autoComplete="new-password"
                                    disabled={!passwordsEnabled}
                                    value={state.ConfirmPassword}
                                    onChange={handleChange('ConfirmPassword', 'confirmPassword')}
                                />
                                <button
                                    type="button"
                                    className="PasswordToggleBtn"
                                    onClick={() => setShowConfirmPassword((p) => !p)}
                                    disabled={!passwordsEnabled}
                                    aria-label={showConfirmPassword ? "Hide password" : "Show password"}>
                                    <EyeIcon open={showConfirmPassword} />
                                </button>
                            </div>
                            {errors.confirmPassword && <span className="ErrorText">{errors.confirmPassword}</span>}
                        </div>

                        <div className="g-recaptcha" style={{ marginTop: '10px' ,width:'100%' ,display:'none'}}>
                            <ReCAPTCHA
                                style={{width:'100%'}}
                                ref={captchaRef}
                                sitekey={RECAPTCHA_SITE_KEY}
                                onChange={(value) => setCaptchaVerified(!!value)}
                                onExpired={() => setCaptchaVerified(false)}
                                onErrored={() => setCaptchaVerified(false)}
                            />
                        </div>

                        <div className="SignUpButtonContainer">
                            <button
                                type="button"
                                className="SignUpButton"
                                id="SignUpBtn"
                                // disabled={!captchaVerified || submitting}
                                onClick={handleSignUp}>
                                {submitting ? 'Signing up...' : 'Sign Up'}
                            </button>
                            <span className="SignInSec">
                                Already have an account?{' '}
                                <a className="SignInLink" href={localStorage.getItem('domain') || '#'}
                                    target="_blank" rel="noopener noreferrer">Sign In</a>
                            </span>
                            <span className="PrivacyPolicySec">
                                <a href="https://smartfm.ae/PrivacyPolicy.html" target="_blank"
                                    rel="noopener noreferrer" className="PrivacyPolicyLink">Privacy Policy</a>
                                {' '}| Terms &amp; Conditions
                            </span>
                        </div>
                    </div>
                </div>
            </div> }

            {
                newTab == 'thankspage' && <SaasProducts
                    state={state}
                    clear={(e) => {
                        if (e) {
                            clear();
                        }
                    }}
                />
            }
        </div>
    );
}